import React from 'react';
import { useParams } from 'react-router-dom';
import { Themes } from '../components';

export default function ThemeDetailsPage(){
    const { id } = useParams();
    return <>
        {/* <SimpleHeader title={`Pauta`} /> */}
        <Themes.Details id={id} />
    </>
}
